import { useDispatch, useSelector } from 'react-redux';
import { Values } from '../interfaces';
import {
  cleanErrorPaymentLink,
  getCreatedPaymentLinks,
  getCurrencies,
  getDocumentTypesForPaymentLink,
  getExistingClients,
  initPaymentLink,
  paymentLinkResult,
  postCreatePaymentLink,
} from './actions';
import { PaymentLinkSelectors } from './selectors';

export const usePaymentLink = () => {
  const dispatch = useDispatch();

  return {
    loading: useSelector(PaymentLinkSelectors.getLoading),
    error: useSelector(PaymentLinkSelectors.getError),
    errorInfo: useSelector(PaymentLinkSelectors.getErrorInfo),
    errorFields: useSelector(PaymentLinkSelectors.getErrorFields),
    createSuccess: useSelector(PaymentLinkSelectors.getCreateSuccess),
    showResult: useSelector(PaymentLinkSelectors.getShowResult),
    currencies: useSelector(PaymentLinkSelectors.getCurrencies),
    documentTypes: useSelector(PaymentLinkSelectors.getDocumentTypes),
    createdPaymentLinks: useSelector(PaymentLinkSelectors.getCreatedPaymentLinks),
    existingClients: useSelector(PaymentLinkSelectors.getExistingClients),
    initPaymentLink: () => dispatch(initPaymentLink()),
    cleanErrorPaymentLink: () => dispatch(cleanErrorPaymentLink()),
    getCurrencies: (country: string) => dispatch(getCurrencies(country)),
    getDocumentTypesForPaymentLink: (country: string) => dispatch(getDocumentTypesForPaymentLink(country)),
    paymentLinkResult: (show: boolean) => dispatch(paymentLinkResult(show)),
    postCreatePaymentLink: (values: Values) => dispatch(postCreatePaymentLink(values)),
    getExistingClients: (page: number, country: string) => dispatch(getExistingClients(page, country)),
    getCreatedPaymentLinks: (page?: number, rowsPerPage?: number) => dispatch(getCreatedPaymentLinks(page, rowsPerPage)),
  };
};
